import Link from 'next/link';

export const FeaturedBanner = () => (
  <div
    className="font-semibold w-full pt-5 pb-4 text-white text-center bg-cover bg-center bg-no-repeat"
    style={{
      backgroundImage: 'url(https://img.gondola.cc/tr:w-1000,h-500,cm-extract,fo-top_left/web-assets/Orange-5.png)',
    }}
  >
    2026 Gondola Sports Summit Tickets are LIVE!
    <div className="space-x-7 justify-center mt-2">
      <Link
        href="/sportssummit26"
        className="btn-secondary"
      >
        BUY TICKETS
      </Link>
    </div>
  </div>
);
